export default __webpack_public_path__ + "static/media/pro@2x.3049fe68.webp";